import React, {
  createContext,
  useEffect,
  useCallback,
  useReducer,
  useContext,
} from "react";

function useAsyncState(initialValue = [true, null]) {
  return useReducer((state, action = null) => [false, action], initialValue);
}

export async function setStorageItemAsync(key, value) {
  if (value == null) {
    localStorage.removeItem(key);
  } else {
    const stringifiedValue = JSON.stringify(value);
    localStorage.setItem(key, stringifiedValue);
  }
}

function useStorageStateWeb(key) {
  const [state, setState] = useAsyncState();

  useEffect(() => {
    let value = localStorage.getItem(key);
    let deserializedValue = null;

    if (value) {
      try {
        deserializedValue = JSON.parse(value);
      } catch (e) {
        console.error("Error parsing stored JSON for key:", key, e);
      }
    }
    setState(deserializedValue);
  }, [key]);

  const setValue = useCallback(
    (value) => {
      setState(value);
      setStorageItemAsync(key, value);
    },
    [key]
  );

  return [state, setValue];
}

const AuthContext = createContext({
  signIn: () => {},
  signOut: () => {},
  session: null,
  isLoading: true,
});

export function useSession() {
  const value = useContext(AuthContext);
  if (!value) {
    throw new Error("useSession must be wrapped in a <SessionProvider />");
  }
  return value;
}

export function SessionProvider({ children }) {
  const [[isLoading, session], setSession] = useStorageStateWeb("session");
  return (
    <AuthContext.Provider
      value={{
        signIn: (user) => {
          setSession(user);
        },
        signOut: () => {
          setSession(null);
        },
        session,
        isLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
